import { useEffect } from 'react';
import { logger } from 'client/utils/isomorphic-logger';
import { PageModel } from 'client/data/models/page';

export function useArticleUrlChange(shouldChangeUrl, article, setModelValue) {
  useEffect(() => {
    if (shouldChangeUrl) {
      try {
        const { articleId, articleCategory, pathname, page } = article;
        if (window.history.pushState && window.location.pathname !== pathname) {
          // This method updates the URL without location change events
          window.history.pushState({}, '', pathname);

          // Ads display logic
          // should be set to legacy value
          // see edwpg/edwcat client/site-modules/shared/components/ads-context/context/page-context.js
          setModelValue('location.pathname', PageModel, pathname);
          setModelValue('legacy', PageModel, page);
          setModelValue('page.adsCustomTargeting', PageModel, {
            sect1: articleId.replace(/[^a-zA-Z0-9]/g, ''),
            sect2: articleCategory.replace(/[^a-zA-Z0-9]/g, ''),
          });
        }
      } catch (e) {
        logger('error', `Not able to update the URL. Error - ${e}`);
      }
    }
  }, [shouldChangeUrl, article, setModelValue]);
}
